<template>
    <div class="container">
        <section id="section" class="section">
            <div class="cell-title ">基本信息</div>
            <div class="cell-group">
                <div class="cell-item">
                    <div class="cell underline">
                        <div class="label">会员编号</div>
                        <!-- <input type="text" class="input" placeholder="请输入会员编号"  v-model="form.UId" /> -->
                        <div v-if="form.UId > 0" @click="openMemberDialog" class="input"
                            style="text-align: left;color:#666">
                            {{ form.UId }}</div>
                        <div v-else @click="openMemberDialog" class="input" style="text-align: left;color:#666">请选择会员
                        </div>
                    </div>
                </div>
                <div class="cell-item">
                    <div class="cell underline">
                        <div class="label">会员姓名</div>
                        <input type="text" class="input" placeholder="请输入会员姓名" v-model="form.info.Name" />
                    </div>
                </div>
                <div class="cell-item">
                    <div class="cell underline">
                        <div class="label">联系电话</div>
                        <input type="text" class="input" placeholder="请输入联系电话" v-model="form.info.Mobile" />
                    </div>
                </div>
                <div class="cell-item">
                    <div class="cell underline">
                        <div class="label">会员性别</div>
                        <!-- <input type="text" class="input" placeholder="请选择" v-model="form.Birthday" /> -->
                        <div class="flex btn-radio__group ml-58">
                            <div @click="onChangeGender(1)" v-bind:class="{ 'cur_btn': form.info.Gender == 1 }"
                                class="btn-radio__item">男</div>
                            <div @click="onChangeGender(2)" v-bind:class="{ 'cur_btn': form.info.Gender == 2 }"
                                class="btn-radio__item">女</div>
                        </div>
                    </div>
                </div>
                <div class="cell-item">
                    <div class="cell underline">
                        <div class="label">会员生日</div>
                        <!-- <input type="text" class="input" placeholder="请输入会员生日" v-model="form.Birthday" /> -->
                        <span @click="showDatePicker = true" class="input" style="color:#333;text-align: left"
                            v-if="form.info.Birthday">
                            {{ form.info.Birthday }}
                        </span>
                        <span @click="showDatePicker = true" class="input" style="color:#999;text-align: left"
                            v-else>请输入会员生日</span>
                    </div>
                </div>
                <div class="cell-item">
                    <div class="cell underline">
                        <div class="label">职业</div>
                        <input type="text" class="input" placeholder="请输入职业" v-model="form.info.Creer" />
                    </div>
                </div>
                <div class="cell-item">
                    <div class="cell underline">
                        <div class="label">职务</div>
                        <input type="text" class="input" placeholder="请输入职务" v-model="form.info.Position" />
                    </div>
                </div>
                <div class="cell-item">
                    <div class="cell ">
                        <div class="label">形象顾问</div>
                        <input type="text" class="input" placeholder="请输入形象顾问名称" v-model="form.info.Consultant" />
                    </div>
                </div>
            </div>
        </section>

        <!-- 色彩分析 -->
        <section id="section" class="section mt-24 pb-24" v-for="(item, index) in labelList" :key="item.Id"
            v-if="index == 0">
            <div class="cell-title ">{{ item.Title }}</div>
            <div class="cell-group">

                <div v-for="(subitem, subindex) in item.Children" :key="subitem.Id" class="cell-item mt-32">
                    <div class="label" style="text-align: left;">
                        {{ subitem.Title }}：
                    </div>
                    <div class="flex mt-24">
                        <div class="flex btn-radio__group">
                            <div @click="handleChooseSingle(index, subindex, thirdIndex)"
                                v-bind:class="{ 'cur_btn': thirdItem.IsCheck }" class="btn-radio__item"
                                v-for="(thirdItem, thirdIndex) in subitem.Children" :key="thirdItem.Id">{{
                                    thirdItem.Title }}</div>
                        </div>
                    </div>
                </div>

            </div>
        </section>

        <!-- 用色规律 -->
        <section id="section" class="section mt-24 pb-24" v-for="(item, index) in labelList" :key="item.Id"
            v-if="index == 1">
            <div class="cell-title ">{{ item.Title }}</div>
            <div class="cell-group">
                <div v-for="(subitem, subindex) in item.Children" :key="subitem.Id" class="cell-item mt-32">
                    <div class="label" style="text-align: left;">
                        {{ subitem.Title }}：
                    </div>
                    <div class="flex mt-24" v-if="subindex < 3">
                        <div class="flex btn-radio__group">
                            <div @click="handleChooseSingle(index, subindex, thirdIndex)"
                                v-bind:class="{ 'cur_btn': thirdItem.IsCheck }" class="btn-radio__item"
                                v-for="(thirdItem, thirdIndex) in subitem.Children" :key="thirdItem.Id">{{
                                    thirdItem.Title }}</div>
                        </div>
                    </div>


                    <div v-if="subindex == 3" class="w-b-wrap">
                        <img class="w-b_left" src="https://mp.yijugongshe.com/upload/backgroundimg/w-b_left_v3.png"
                            alt="">
                        <div class="w-b_right " @click.stop="setPoint">
                            <div v-if="top && left" :style="{ top: `${top}px`, left: `${left}px` }"
                                class="w-b__circle no-click"></div>
                        </div>
                    </div>
                </div>

            </div>
        </section>

        <!-- 形象风格板 -->
        <section id="section" class="section mt-24">
            <div class="cell-title ">形象风格板</div>
            <div class="cell-group">
                <div class="cell-item">
                    <div class=" underline">
                        <div class="">
                            <van-field @blur="fieldBlur()" v-model="form.info.MySelf" rows="2" autosize label="我眼中的自己"
                                type="textarea" maxlength="200" placeholder="请输入" show-word-limit />
                        </div>
                    </div>
                </div>
                <div class="cell-item">
                    <div class=" underline">
                        <div class="">
                            <van-field @blur="fieldBlur()" v-model="form.info.MySelfInOtherEye" rows="2" autosize
                                label="别人眼中的我" type="textarea" maxlength="200" placeholder="请输入" show-word-limit />
                        </div>
                    </div>
                </div>
                <div class="cell-item">
                    <div class=" underline">
                        <div class="">
                            <van-field @blur="fieldBlur()" v-model="form.info.IWantToBe" rows="2" autosize
                                label="我想成为的人" type="textarea" maxlength="200" placeholder="请输入" show-word-limit />
                        </div>
                    </div>
                </div>
                <div class="cell-item">
                    <div class=" underline">
                        <div class="">
                            <van-field @blur="fieldBlur()" v-model="form.info.Avantage" rows="2" autosize label="优势&挑战"
                                type="textarea" maxlength="200" placeholder="请输入" show-word-limit />
                        </div>
                    </div>
                </div>
                <div class="cell-item">
                    <div class=" underline">
                        <div class="">
                            <van-field @blur="fieldBlur()" v-model="form.info.Target" rows="2" autosize label="价值观&目标"
                                type="textarea" maxlength="200" placeholder="请输入" show-word-limit />
                        </div>
                    </div>
                </div>
                <div class="cell-item">
                    <div class=" underline">
                        <div class="">
                            <van-field @blur="fieldBlur()" v-model="form.info.ExclusiveStyle" rows="2" autosize
                                label="专属风格" type="textarea" maxlength="200" placeholder="请输入" show-word-limit />
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 身形特征 -->
        <section id="section" class="section mt-24 pb-24">
            <div class="cell-title ">身形特征</div>
            <div class="cell-group">
                <div class="cell-item">
                    <div class="cell underline">
                        <div class="label">头围</div>
                        <input @blur="fieldBlur()" type="text" class="input" placeholder="请输入"
                            v-model="form.info.HeadCircumference" />
                    </div>
                </div>
                <div class="cell-item">
                    <div class="cell underline">
                        <div class="label">肩宽</div>
                        <input @blur="fieldBlur()" type="text" class="input" placeholder="请输入"
                            v-model="form.info.ShoulderWidth" />
                    </div>
                </div>
                <div class="cell-item">
                    <div class="cell underline">
                        <div class="label">胸围</div>
                        <input @blur="fieldBlur()" type="text" class="input" placeholder="请输入"
                            v-model="form.info.Bust" />
                    </div>
                </div>
                <div class="cell-item">
                    <div class="cell underline">
                        <div class="label">腰围</div>
                        <input @blur="fieldBlur()" type="text" class="input" placeholder="请输入"
                            v-model="form.info.MidWaistCircumference" />
                    </div>
                </div>
                <div class="cell-item">
                    <div class="cell underline">
                        <div class="label">臀围</div>
                        <input @blur="fieldBlur()" type="text" class="input" placeholder="请输入"
                            v-model="form.info.Hips" />
                    </div>
                </div>
                <div class="cell-item">
                    <div class="cell underline">
                        <div class="label">大腿围</div>
                        <input @blur="fieldBlur()" type="text" class="input" placeholder="请输入"
                            v-model="form.info.ThighCircumference" />
                    </div>
                </div>
                <div class="cell-item">
                    <div class="cell underline">
                        <div class="label">鞋码</div>
                        <input @blur="fieldBlur()" type="text" class="input" placeholder="请输入"
                            v-model="form.info.ShoeSize" />
                    </div>
                </div>
                <div class="cell-item" v-for="(item, index) in labelList" :key="item.Id" v-if="index == 2">
                    <div class="cell-group underline pb-24">
                        <div v-for="(subitem, subindex) in item.Children" :key="subitem.Id" class="mt-32">
                            <div class="label" style="text-align: left;">
                                {{ subitem.Title }}：
                            </div>
                            <div class="flex mt-24">
                                <div class="flex btn-radio__group">
                                    <div @click="subitem.ChooseType == 1 ? handleChooseSingle(index, subindex, thirdIndex) : handleChooseMulti(index, subindex, thirdIndex)"
                                        v-bind:class="{ 'cur_btn': thirdItem.IsCheck }" class="btn-radio__item"
                                        v-for="(thirdItem, thirdIndex) in subitem.Children" :key="thirdItem.Id">{{
                                            thirdItem.Title }}</div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </section>

        <!-- 建议化妆用色 -->
        <section id="section" class="section mt-24 pb-24" v-for="(item, index) in labelList" :key="item.Id"
            v-if="index == 3">
            <div class="cell-title ">{{ item.Title }}</div>
            <div class="cell-group">
                <div class="cell-item mt-32" v-for="(subitem, subindex) in item.Children" :key="subitem.Id">
                    <div class="label" style="text-align: left;">{{ subitem.Title }}：</div>
                    <div style="display: flex;flex-wrap: wrap">
                        <div v-for="(thirdItem, thirdIndex) in subitem.LabelImageListFull" :key="subitem.Image"
                            style="position: relative;">
                            <img @click="handleChooseImageMulti(index, subindex, thirdIndex)" :src="thirdItem.Image"
                                alt="" class="option_img" v-bind:class="{ 'cur': thirdItem.IsCheck }">
                            <span v-show="thirdItem.IsCheck" style="color:#861517" class="ico_selected">✔</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 个人整体形象建议 -->
        <section id="section" class="section mt-24 pb-24">
            <div v-for="(item, index) in labelList" :key="item.Id" v-if="index == 4">
                <h6 style="margin: 0;">{{ item.Title }}</h6>
                <div v-for="(subitem, subindex) in item.Children" :key="subitem.Id">
                    <div class="mt-24" v-if="subindex == 0">
                        <div class="cell-title ">{{ subitem.Title }}</div>
                        <div class="cell-group">
                            <div class="cell-item mt-32" v-for="(thirdItem, thirdIndex) in subitem.Children">
                                <div class="label" style="text-align: left;">{{ thirdItem.Title }}：</div>
                                <div class="flex mt-24">
                                    <div v-for="(colorItem, colorIndex) in thirdItem.ImageList" :key="colorIndex"
                                        class="relative">
                                        <div @click="openColorsPicker(index, subindex, thirdIndex, colorIndex)"
                                            class="color-block" :style="{ 'background-color': colorItem }">
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="mt-24" v-if="subindex == 1">
                        <div class="cell-title ">{{ subitem.Title }}</div>
                        <div class="flex items-center">
                            <img v-if="form.info.Gender == 1" class="ico_people"
                                src="https://mp.yijugongshe.com/upload/backgroundimg/Business_Man.png" alt="">
                            <img class="ico_people" v-if="form.info.Gender == 2"
                                src="https://mp.yijugongshe.com/upload/backgroundimg/Business_Lady.png" alt="">
                            <div class="cell-group">
                                <div class="flex flex-row flex-1 flex-wrap">
                                    <div class="daItemList" v-for="(thirdItem, thirdIndex) in subitem.Children"
                                        :key="thirdIndex">
                                        <div v-for="(colorItem, colorIndex) in thirdItem.ImageList" :key="colorIndex"
                                            class="daItem" :style="{ background: colorItem }"
                                            @click="openColorsPicker(index, subindex, thirdIndex, colorIndex)"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-24" v-if="subindex == 2">
                        <div class="cell-title mt-32">{{ subitem.Title }}</div>
                        <div class="cell-group">
                            <div class="cell-item mt-32">
                                <div class="flex mt-24">
                                    <van-checkbox-group v-model="checkboxList" direction="horizontal"
                                        checked-color="#861517">
                                        <van-checkbox @click="handleChooseMulti(index, subindex, thirdIndex)"
                                            ref="checkboxes" v-for="(thirdItem, thirdIndex) in subitem.Children"
                                            :key="thirdItem.Id" shape="square" :name="thirdItem.Id">{{ thirdItem.Title
                                            }}</van-checkbox>
                                    </van-checkbox-group>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-24" v-if="subindex == 3">
                        <div class="cell-title mt-32">{{ subitem.Title }}</div>
                        <div class="cell-group">
                            <div class="cell-item mt-32">
                                <div class="flex mt-24">
                                    <van-checkbox-group v-model="styleCheckboxList" direction="horizontal"
                                        checked-color="#861517">
                                        <van-checkbox @click="handleChooseMulti(index, subindex, thirdIndex)"
                                            ref="checkboxes" v-for="(thirdItem, thirdIndex) in subitem.Children"
                                            :key="thirdItem.Id" shape="square" :name="thirdItem.Id">{{ thirdItem.Title
                                            }}</van-checkbox>
                                    </van-checkbox-group>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-24" v-if="subindex == 4">
                        <div class="cell-title mt-32">{{ subitem.Title }}</div>
                        <div class="cell-group">
                            <div class="cell-item mt-32">
                                <div class="flex mt-24">
                                    <van-checkbox-group v-model="clothingStyleCheckboxList" direction="horizontal"
                                        checked-color="#861517">
                                        <van-checkbox @click="handleChooseMulti(index, subindex, thirdIndex)"
                                            ref="checkboxes" v-for="(thirdItem, thirdIndex) in subitem.Children"
                                            :key="thirdItem.Id" shape="square" :name="thirdItem.Id">{{ thirdItem.Title
                                            }}</van-checkbox>
                                    </van-checkbox-group>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-24" v-if="subindex == 5">
                        <div class="cell-title mt-32">{{ subitem.Title }}</div>
                        <div class="cell-group">
                            <div class="cell-item mt-32">
                                <div class="flex mt-24">
                                    <van-checkbox-group v-model="clothingSenseCheckboxList" direction="horizontal"
                                        checked-color="#861517">
                                        <van-checkbox @click="handleChooseMulti(index, subindex, thirdIndex)"
                                            ref="checkboxes" v-for="(thirdItem, thirdIndex) in subitem.Children"
                                            :key="thirdItem.Id" shape="square" :name="thirdItem.Id">{{ thirdItem.Title
                                            }}</van-checkbox>
                                    </van-checkbox-group>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- <div class="cell-title mt-32">服饰搭配</div>
            <div class="cell-group">
                <div class="cell-item mt-32">
                    <div class="label" style="text-align: left;">服装款式：</div>
                    <div class="">
                        <div class="cell underline">
                            <div class="label">基本款</div>
                            <input type="text" @blur="fieldBlur(form.info.BasicModel)" class="input" placeholder="请输入"
                                v-model="form.info.BasicModel" />
                        </div>
                        <div class="cell underline">
                            <div class="label">经典款</div>
                            <input type="text" @blur="fieldBlur(form.info.Classic)" class="input" placeholder="请输入"
                                v-model="form.info.Classic" />
                        </div>
                        <div class="cell underline">
                            <div class="label">装饰款</div>
                            <input type="text" @blur="fieldBlur(form.info.Decoration)" class="input" placeholder="请输入"
                                v-model="form.info.Decoration" />
                        </div>
                    </div>
                </div>
            </div> -->

            <div v-for="(item, index) in labelList" :key="item.Id" v-if="index == 5">
                <div class="cell-title mt-32">{{ item.Title }}</div>
                <div class="cell-group">
                    <div v-for="(subitem, subindex) in item.Children" :key="subitem.Id" class="cell-item mt-32">
                        <div class="label" style="text-align: left;">
                            {{ subitem.Title }}：
                        </div>
                        <div class="flex mt-24">
                            <div class="flex btn-radio__group">
                                <div @click="handleChooseSingle(index, subindex, thirdIndex)"
                                    v-bind:class="{ 'cur_btn': thirdItem.IsCheck }" class="btn-radio__item"
                                    v-for="(thirdItem, thirdIndex) in subitem.Children" :key="thirdItem.Id">{{
                                        thirdItem.Title }}</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div v-for="(item, index) in labelList" :key="item.Id" v-if="index == 6">
                <div class="cell-title mt-32">{{ item.Title }}</div>
                <div class="cell-group">
                    <div v-for="(subitem, subindex) in item.Children" :key="subitem.Id" class="cell-item mt-32">
                        <div class="label" style="text-align: left;">
                            {{ subitem.Title }}：
                        </div>
                        <div class="flex mt-24">
                            <div class="flex btn-radio__group">
                                <div @click="handleChooseSingle(index, subindex, thirdIndex)"
                                    v-bind:class="{ 'cur_btn': thirdItem.IsCheck }" class="btn-radio__item"
                                    v-for="(thirdItem, thirdIndex) in subitem.Children" :key="thirdItem.Id">{{
                                        thirdItem.Title }}</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div v-for="(item, index) in labelList" :key="item.Id" v-if="index == 7">
                <div class="cell-title mt-32">{{ item.Title }}</div>
                <div class="cell-group">
                    <div class="cell-item mt-32">
                        <div class="flex ">
                            <van-checkbox-group v-model="clothLineList" direction="horizontal" checked-color="#861517">
                                <van-checkbox @click="handleChooseMulti(index, subindex)" ref="checkboxes"
                                    v-for="(subitem, subindex) in item.Children" :key="subitem.Id" shape="square"
                                    :name="subitem.Id">{{
                                        subitem.Title }}</van-checkbox>
                            </van-checkbox-group>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-32">
                <div class="cell-item">
                    <div class="cell underline">
                        <div class="label">饰品搭配</div>
                        <input @blur="fieldBlur()" type="text" class="input" placeholder="请输入"
                            v-model="form.info.JewelryMatching" />
                    </div>
                </div>
                <div class="cell-item">
                    <div class="cell underline">
                        <div class="label">平衡点选择</div>
                        <input @blur="fieldBlur()" type="text" class="input" placeholder="请输入"
                            v-model="form.info.BalancePointSelection" />
                    </div>
                </div>
            </div>
        </section>

        <!-- 图片 -->
        <section id="section" class="section mt-24 pb-24" v-for="(item, index) in labelList" :key="item.Id"
            v-if="index == 8">
            <div class="cell-title ">{{ item.Title }}</div>
            <div class="cell-group">
                <div class="cell-item" v-for="(subitem, subindex) in item.Children" :key="subitem.Id">
                    <div class="flex-column cell-upload underline">
                        <div class="label padding-bottom-20" style="text-align: left">
                            {{ subitem.Title }}
                        </div>
                        <div class="flex">
                            <div class="mt-32">
                                <div v-if='subitem.ImageListFull.length > 0' class="flex">
                                    <div class="uploadImg-wrap relative"
                                        v-for="(imgItem, imgIndex) in subitem.ImageListFull" :key="imgIndex">
                                        <img :src='imgItem' class='img'></img>
                                        <img @click="onRemoveImg(index, subindex)"
                                            src='https://mp.yijugongshe.com/upload/backgroundimg/icon_close.png'
                                            class='imgclose'>
                                    </div>
                                </div>
                                <div v-else class="flex-1 flex-column">
                                    <van-uploader :name="subindex" :multiple="false" max-count="1" preview-size="120"
                                        image-fit="contain" :after-read="afterRead" />
                                    <div style="text-align: left" class="font-size-22">
                                        建议比例 3:4
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 服务记录 -->
        <section id="section" class="section mt-24" v-if="false">
            <div class="flex justify-between items-center title-wrap">
                <div class="cell-title ">服务记录</div>
                <div class="font-size-28" @click="showRecord = true">查看记录></div>
            </div>
            <div class="cell-group">

                <div class="cell-item">
                    <div class=" underline">
                        <div class="">
                            <van-field style="padding-left: 0;" v-model="form.Remark" rows="2" autosize label="记录"
                                type="textarea" maxlength="300" placeholder="请输入" show-word-limit />
                        </div>
                    </div>
                </div>

                <div class="flex mx-24">
                    <div class="mt-32 flex flex-wrap">
                        <div v-if='form.RemarkImageListFull.length > 0' class="flex">
                            <div class="uploadImg-wrap relative" v-for="(imgItem, imgIndex) in form.RemarkImageListFull"
                                :key="imgIndex">
                                <img :src='imgItem' class='img'></img>
                                <img @click="onRemoveRemarkImg(imgIndex)"
                                    src='https://mp.yijugongshe.com/upload/backgroundimg/icon_close.png'
                                    class='imgclose'>
                            </div>
                        </div>
                        <div v-if='form.RemarkImageListFull.length < 3' class="flex-1 flex-column">
                            <van-uploader name="RemarkImageList" :multiple="false" preview-size="60" image-fit="contain"
                                :after-read="afterReadRemarkImageList" />
                            <div style="text-align: left" class="font-size-22">
                                建议比例 3:4
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="flex justify-center fixed-bottom">
            <div class="mr-24">
                <van-button plain type="info" @click="handleSave">
                    保存修改内容
                </van-button>
            </div>
            <div class="">
                <van-button type="info" @click="handleCreate">立即生成报告</van-button>
            </div>
        </div>


        <van-popup v-model="showColorsPicker" click-overlay="closeColorsPicker">
            <div class="picker-wrap">
                <chrome-picker v-model="color" @input="updateValue" />
                <van-button type="info" @click="closeColorsPicker()">确认</van-button>
            </div>
        </van-popup>
        <van-popup v-model="showMembers" closeable position="bottom" click-overlay="onClose" :style="{ height: '50%' }">
            <div class="box-border p-32">
                <div class="color-333  text-center font-size-28">选择会员</div>
                <div>
                    <van-field v-model="NickName" center clearable label="快速搜索" placeholder="请输入昵称/手机">
                        <template #button>
                            <van-button size="small" type="primary" @click="getMembers">搜索</van-button>
                        </template>
                    </van-field>
                </div>
                <div class="">
                    <div v-for="(item, index) in memberList" :key="item.UId">
                        <div @click="onConfirmChoose(item)" class="list__item text-center mt-24 font-size-28 color-333 "
                            v-bind:class="{ 'cur': item.UId == form.UId }">
                            <span>{{ item.NickName }} </span>
                            <span v-if="item.Mobile"> - {{ item.Mobile }} </span>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="showRecord" closeable position="bottom" click-overlay="onClose" :style="{ height: '50%' }">
            <div class="box-border p-32">
                <div class="color-333  text-center font-size-28">查看记录</div>
                <van-swipe-cell v-for="(item, index) in form.ServeLists" :key="index">
                    <div class="cell-item">
                        <div class=" underline">
                            <div class="">
                                <van-field disabled style="padding-left: 0;" v-model="item.Remark" rows="2" autosize
                                    :label="`记录(${item.Date})`" type="textarea" maxlength="300" placeholder="空" />
                            </div>
                        </div>
                    </div>
                    <template #right>
                        <!-- <van-button square text="删除" type="danger" class="delete-button" @click="deleteServe(index)" /> -->
                    </template>
                </van-swipe-cell>
            </div>
        </van-popup>
        <van-popup v-model="showDatePicker" position="bottom" click-overlay="onClose" :style="{ height: '50%' }">
            <van-datetime-picker @confirm="onConfirmDatePicker" v-model="form.Birthday" type="date" title="选择年月日"
                :min-date="minDate" :max-date="maxDate" />
        </van-popup>
    </div>
</template>

<script>
import Vue from "vue";
import { Button, DatetimePicker, Slider, Field, RadioGroup, Radio, Popup, Checkbox, CheckboxGroup, uploader, Dialog, Toast, SwipeCell, } from 'vant'
import {
    Chrome,
} from "vue-color";
import moment from 'moment'
import { AddUserReport, GetUserReport, GetCashierUserList, AddUserLabel, uploadFileApi } from "@/api/label";
import util from "@/utils/getToken";

Vue.use(Button);
Vue.use(DatetimePicker);
Vue.use(Slider);
Vue.use(Field);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Popup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(uploader);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(SwipeCell);

export default {
    components: {
        "chrome-picker": Chrome,
    },

    watch: {
        // checkboxList(newVal, oldVal) {
        //   console.log('oldVal: ', oldVal);
        //   console.log('newVal: ', newVal);
        // }
    },

    data() {
        return {
            form: {

                UId: "",
                NickName: "",
                Mobile: "",
                Birthday: "",
                Creer: "",
                Position: "",
                Consultant: "",
                // Remark: "形象诊断第一次服务，进行了 xxxx 测试。根据客户需求，建议使用 xxxxx 的用色方式。目标形象建议  xxxxx",//
                Remark: "",//
                RemarkImageList: [],
                RemarkImageListFull: [],

                info: {
                    MySelf: "",
                    MySelfInOtherEye: "",
                    IWantToBe: "",
                    Avantage: "",
                    Target: "",
                    ExclusiveStyle: "",
                    HeadCircumference: "",
                    ShoulderWidth: "",
                    Bust: "",
                    UpperWaistCircumference: "",
                    MidWaistCircumference: "",
                    LowWaistCircumference: "",
                    Hips: "",
                    ThighCircumference: "",
                    ShoeSize: "",
                    BasicModel: "",
                    Classic: "",
                    Decoration: "",
                    JewelryMatching: "",
                    BalancePointSelection: "",
                    Remark: "",

                    "Name": "",
                    "Birthday": "",
                    "Consultant": "",
                    "Mobile": "",
                    "Creer": "",
                    "Position": "",
                    "Gender": 2,
                },
                ServeLists: [],
            },

            // 会员选择相关变量
            showMembers: false,
            memberList: [],
            NickName: "",

            // 标签选项
            labelList: [],

            // 多选变量
            checkboxList: [],
            styleCheckboxList: [],
            clothingStyleCheckboxList: [],
            clothingSenseCheckboxList: [],

            clothLineList: [],

            // 颜色选择相关变量
            showColorsPicker: false,
            color: '',
            tempIndex: 0,
            tempSubIndex: 0,
            tempThirdIndex: 0,
            tempColorIndex: 0,
            // 颜色选择相关变量


            UncommittedList: [],//收集已改变，但未提交的修改项目

            left: undefined,
            top: undefined,

            showRecord: false,


            minDate: new Date(1950, 0, 1),
            maxDate: new Date(),
            showDatePicker: false,
        };
    },
    created() {

        // this.form.UId = 2235;
        // this.getReport();
    },
    methods: {
        getMembers() {
            GetCashierUserList({
                Keyword: "",
                Mobile: this.NickName,
                NickName: "",
                Page: { PageIndex: 1, PageSize: 500 },
                StoreId: 0,
                UserRId: 0,
            }).then((res) => {
                // console.log(res);
                let temp = res.Data.CashierUserInfoList;
                this.memberList = temp
            })
        },
        onClose() {
            this.showMembers = false;
            this.showDatePicker = false;
        },
        onConfirmChoose(item) {
            let {
                Gender,
                UId,
                NickName,
                Mobile,
            } = item;
            this.form.UId = UId;
            this.form.info.Gender = Gender == 0 ? 2 : 1;
            this.form.info.NickName = NickName;
            this.form.info.Mobile = Mobile;
            this.showMembers = false;
            // console.log('onConfirmChoose this.form.info.Gender: ', this.form.info.Gender);
            this.getReport();
        },
        onChangeGender(val) {
            this.form.info.Gender = val;
            if (this.form.UId > 0) {
                // console.log('onChangeGender this.form.info.Gender: ', this.form.info.Gender);
                this.getReport();
            }
        },
        getReport() {
            GetUserReport(
                {
                    "UserId": this.form.UId,
                    "Gender": this.form.info.Gender,
                    "Page": {
                        "PageIndex": 1,
                        "PageSize": 999999
                    }
                }
            ).then((res) => {
                // console.log(res);
                // console.log(res.Data);
                let {
                    UserInfo,
                    List,
                    Data,
                    ServeLists,
                } = res.Data;
                this.form.info = Data
                this.form.info.Gender = UserInfo.Gender;
                this.form.ServeLists = ServeLists;
                this.form.info.Name = UserInfo.Name;
                this.form.info.Mobile = UserInfo.Mobile;
                this.form.info.Consultant = UserInfo.Consultant;
                this.form.info.Creer = UserInfo.Creer;
                this.form.info.Position = UserInfo.Position;
                this.form.info.Birthday = UserInfo.BirthdayStr;

                this.labelList = List;
                /* 获取色系图左移和上移 */
                this.left = Number(List[1].Children[3].ImageList[0])
                this.top = Number(List[1].Children[3].ImageList[1])
                /* 结束 */

                /* 个人整体形象建议 开始 */
                const advise_child = List[4].Children
                // 顺序是固定的--建议之场景用色
                advise_child[0].Children.forEach(item => {
                    if (item.ImageList.length == 0) {
                        item.ImageList = new Array(5).fill('#ecf2ee', 0, 5);
                    } else if (item.ImageList.length == 5) {
                        // return
                    } else {
                        item.ImageList = item.ImageList.concat(new Array(5 - item.ImageList.length).fill('#ecf2ee', 0, 5));
                    }
                })
                // 顺序是固定的--建议之搭配规律
                advise_child[1].Children.forEach(item => {
                    if (item.ImageList.length == 0) {
                        item.ImageList = new Array(3).fill('#ecf2ee', 0, 3);
                    } else if (item.ImageList.length == 5) {
                        // return
                    } else {
                        item.ImageList = item.ImageList.concat(new Array(3 - item.ImageList.length).fill('#ecf2ee', 0, 3));
                    }
                })
                // 顺序是固定的--建议之色彩搭配
                this.checkboxList = advise_child[2].Children.filter(item => item.IsCheck).map(item => item.Id)
                // 顺序是固定的--建议之服饰搭配
                this.styleCheckboxList = advise_child[3].Children.filter(item => item.IsCheck).map(item => item.Id)
                // 顺序是固定的--建议之风格
                this.clothingStyleCheckboxList = advise_child[4].Children.filter(item => item.IsCheck).map(item => item.Id)
                // 顺序是固定的--建议之场合服装
                this.clothingSenseCheckboxList = advise_child[5].Children.filter(item => item.IsCheck).map(item => item.Id)
                /* 结束 */

                this.clothLineList = List[7].Children.filter(item => item.IsCheck).map(item => item.Id) // 顺序是固定的--建议之色彩搭配

            })
        },
        collectUncommitted(changes, type) {
            const collectSingle = (changes) => {
                if (this.UncommittedList.length > 0) {
                    changes.forEach(change => {
                        const index = this.UncommittedList.findIndex(item => item.ParentId === change.ParentId);
                        if (index !== -1) {
                            this.UncommittedList[index] = change; // Update existing item
                        } else {
                            this.UncommittedList.push(change); // Add new item
                        }
                    });
                } else {
                    this.UncommittedList = this.UncommittedList.concat(changes);
                }
            }
            const collectMulti = (changes) => {
                let ParentId = changes[0].ParentId;
                if (this.UncommittedList.length > 0) {

                    const condition = (item) => item.ParentId === ParentId;// 定义筛选条件，选中 ParentId 已存在的所有项
                    this.UncommittedList = this.UncommittedList.filter(item => !condition(item)) //取反
                }
                this.UncommittedList = this.UncommittedList.concat(changes);
            }
            switch (type) {
                case 'single':
                    collectSingle(changes);
                    break;
                case 'multi':
                    collectMulti(changes)
                    break;
                default:

                    break;
            }
            // Log the updated UncommittedList for debugging purposes.
            console.log('this.UncommittedList:', this.UncommittedList);
        },
        handleChooseSingle(index, subindex, thirdIndex) {
            console.log('thirdIndex: ', thirdIndex);
            if (thirdIndex > 0 || thirdIndex == 0) {
                // 三级
                let current = this.labelList[index].Children[subindex].Children;
                current.forEach(item => {
                    item.IsCheck = false;
                })
                current[thirdIndex].IsCheck = !current[thirdIndex].IsCheck;
                this.collectUncommitted([current[thirdIndex]], 'single')
                // this.addLabelWithChoose([current[thirdIndex]])

            } else {
                // 两级
                let current = this.labelList[index].Children;
                current.forEach(item => {
                    item.IsCheck = false;
                })
                current[subindex].IsCheck = !current[subindex].IsCheck;
                this.collectUncommitted([current[subindex]], 'single')
            }
        },
        handleChooseMulti(index, subindex, thirdIndex) {
            console.log('thirdIndex: ', thirdIndex);
            if (thirdIndex > 0 || thirdIndex == 0) {
                console.log('进来了三级');
                let current = this.labelList[index].Children[subindex].Children;
                current[thirdIndex].IsCheck = !current[thirdIndex].IsCheck;
                let filterArr = current.filter(item => item.IsCheck);
                // this.addLabelWithChoose(filterArr)
                console.log('filterArr: ', filterArr);
                this.collectUncommitted(filterArr, 'multi')

            } else {
                console.log('进来了二级');
                let current = this.labelList[index].Children;
                // console.log('current: ', current);
                current[subindex].IsCheck = !current[subindex].IsCheck;
                let filterArr = current.filter(item => item.IsCheck);
                // this.addLabelWithChoose(filterArr)
                this.collectUncommitted(filterArr, 'multi')

            }
        },
        handleChooseImageMulti(index, subindex, thirdIndex) {
            console.log('thirdIndex: ', thirdIndex);
            if (thirdIndex > 0 || thirdIndex == 0) {
                // 三级
                let current = this.labelList[index].Children[subindex].LabelImageList;
                let currentFull = this.labelList[index].Children[subindex].LabelImageListFull;
                // console.log('current: ', current);
                current[thirdIndex].IsCheck = !current[thirdIndex].IsCheck;
                currentFull[thirdIndex].IsCheck = !currentFull[thirdIndex].IsCheck;
                let filterArr = current.filter(item => item.IsCheck).map(item => item.Image);
                let List = [{
                    ImageList: filterArr,
                    Id: this.labelList[index].Children[subindex].Id,
                    ParentId: this.labelList[index].Children[subindex].ParentId,
                }]
                this.addLabelWithChoose(List)
            }
        },
        addLabelWithChoose(list) {

            AddUserLabel({
                "UId": this.form.UId,
                "Gender": this.form.info.Gender,
                "List": list,
                "Data": this.form.info,
            }
            ).then(res => {

            })
        },
        fieldBlur(val) {
            // console.log('>>', val);//可以打出值 
            // this.addLabelWithInput();
        },
        addLabelWithInput() {
            AddUserLabel({
                "UId": this.form.UId,
                "Gender": this.form.info.Gender,
                "List": [],
                "Data": this.form.info
            }
            ).then(res => {

            })
        },
        openMemberDialog() {
            this.showMembers = true;
            this.getMembers()

        },
        /* 颜色选择器开始 */
        openColorsPicker(index, subindex, thirdIndex, colorIndex) {
            console.log('openColorsPicker: ');

            this.tempIndex = index;
            this.tempSubIndex = subindex;
            this.tempThirdIndex = thirdIndex;
            this.tempColorIndex = colorIndex;
            this.showColorsPicker = true;
        },
        closeColorsPicker() {
            this.showColorsPicker = false;
            this.setColorValue(this.tempIndex, this.tempSubIndex, this.tempThirdIndex, this.tempColorIndex);
        },
        setColorValue(index, subindex, thirdIndex, colorIndex) {
            try {
                this.labelList[index].Children[subindex].Children[thirdIndex].ImageList[colorIndex] = this.color;

                let current = this.labelList[index].Children[subindex].Children[thirdIndex];
                let filterArr = current.ImageList.filter(item => {
                    return item != "#ecf2ee"
                });
                console.log('filterArr: ', filterArr);

                let List = [{
                    ImageList: filterArr,
                    Id: current.Id,
                    ParentId: current.ParentId,
                }]
                this.addLabelWithChoose(List)
            } catch (error) {
                console.error('Error setting color value:', error);
            }
        },
        updateValue(value) {
            // console.log('value>>', value);
            console.log('value.hex: ', value.hex);
            this.color = value.hex;
        },
        /* 颜色选择器结束 */

        async afterRead(file, name) {
            // 此时可以自行将文件上传至服务器
            // console.log(file);
            let res = await uploadFileApi(file.file)
            let FullImgUrl = res.Data.FullImgUrl;
            let ImgUrl = res.Data.ImgUrl;


            let current = this.labelList[8].Children[name.name];
            current.ImageList = [ImgUrl]
            current.ImageListFull = [FullImgUrl]
            let filterArr = current.ImageList;
            let List = [{
                ImageList: filterArr,
                Id: current.Id,
                ParentId: current.ParentId,
            }]

            this.addLabelWithChoose(List)

        },
        async afterReadRemarkImageList(file, name) {
            // 此时可以自行将文件上传至服务器
            // console.log(file);
            let res = await uploadFileApi(file.file)
            let FullImgUrl = res.Data.FullImgUrl;
            let ImgUrl = res.Data.ImgUrl;

            this.form.RemarkImageList.push(ImgUrl)
            this.form.RemarkImageListFull.push(FullImgUrl)
            console.log('短', this.form.RemarkImageList);
            console.log('长', this.form.RemarkImageListFull);

        },
        onRemoveImg(index, subindex, thirdIndex) {
            let current = this.labelList[index].Children[subindex];
            current.ImageList = [];
            current.ImageListFull = [];
        },
        onRemoveRemarkImg(index) {

            this.form.RemarkImageList.splice(index, 1)
            this.form.RemarkImageListFull.splice(index, 1)
        },
        deleteServe(index) {
            this.form.ServeLists.splice(index, 1);
        },
        handleSave() {

            // 自定义加载图标
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
                loadingType: 'spinner',
                duration: 0,
            });
            // console.log('this.UncommittedList: ', this.UncommittedList);
            AddUserLabel({
                "UId": this.form.UId,
                "Gender": this.form.info.Gender,
                "List": this.UncommittedList,
                "Data": this.form.info,
            }
            ).then(res => {
                this.UncommittedList = []; // 提交后清空收集
                Toast.success({
                    message: '已保存',
                    duration: 1000,
                });
                setTimeout(() => {
                    Toast.clear();
                }, 1000);
            }).catch(err => {
                Toast.clear();
            })
        },
        handleCreate() {
            // 自定义加载图标
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
                loadingType: 'spinner',
                duration: 0,
            });
            // console.log('this.UncommittedList: ', this.UncommittedList);
            AddUserLabel({
                "UId": this.form.UId,
                "Gender": this.form.info.Gender,
                "List": this.UncommittedList,
                "Data": this.form.info,
            }
            ).then(res => {
                this.UncommittedList = []; // 提交后清空收集
                Toast.success({
                    message: '已保存',
                    duration: 1000,
                });
                setTimeout(() => {
                    Toast.clear();
                    Dialog.confirm({
                        title: '提示',
                        message: `确定要为用户 - ${this.form.info.Name} 生成形象报告吗`,
                    })
                        .then(() => {

                            console.log('on confirm: ');
                            AddUserReport(
                                {
                                    "UserId": this.form.UId,
                                    "Name": this.form.info.Name,
                                    "Birthday": this.form.info.Birthday,
                                    "Consultant": this.form.info.Consultant,
                                    "Mobile": this.form.info.Mobile,
                                    "Creer": this.form.info.Creer,
                                    "Position": this.form.info.Position,
                                    "Gender": this.form.info.Gender,
                                    "Remark": this.form.Remark,
                                    "ImageList": [],
                                    "RemarkImageList": this.form.RemarkImageList,
                                }
                            ).then(() => {
                                // Toast.success({
                                //     message: '已保存',
                                //     duration: 1000,
                                // });
                                this.$router.push({
                                    path: '/report',
                                    query: {
                                        userId: this.form.UId,
                                    }
                                })
                            })
                        })
                        .catch(() => {
                            console.log('on cancel: ');
                        });
                }, 1000);
            }).catch(err => {
                Toast.clear();
            })


        },
        setPoint(e) {
            e = e || window.event;
            let x = e.offsetX || e.layerX;
            let y = e.offsetY || e.layerY;
            console.log('x: ', x);
            console.log('y: ', y);

            // // console.log('屏幕宽度>>>', window.screen.width);
            let screenWidth = window.screen.width;
            let rate = 750 / screenWidth;


            let circle_half = 100 / (rate * 2);//100是圆圈的宽高，


            let read_y = y - circle_half;
            let read_x = x - circle_half;
            this.top = read_y;
            this.left = read_x;

            let current = this.labelList[1].Children[3]
            current.ImageList = [read_x, read_y]
            this.collectUncommitted([current], 'single')
        },

        onConfirmDatePicker(val) {
            let date = moment(val).format('YYYY-MM-DD');
            console.log('date: ', date);
            this.form.info.Birthday = date;
            this.showDatePicker = false;
        },
    },

    mounted() {
        // console.log('that.$route.query: ', this.$route.query);
        util.getToken(this.$route.query.userId);
    },

};
</script>

<style scoped>
@import url(/src/utils/commonStyle.css);

/* 正式开始 */
.container {
    background-color: #f5f5f5;
    box-sizing: border-box;
    padding: 24px 24px 154px 24px;
}

.section {
    background-color: #fff;
    border-radius: 24px;
    box-sizing: border-box;
    padding: 24px 0 0 0;
}

.cell-group {
    box-sizing: border-box;
}

.cell-item {
    box-sizing: border-box;
    padding: 0 28px;
    width: 100%;

    font-size: 28px;
}

.flex-column {
    display: flex;
    flex-direction: column;
}

.cell-gap {
    width: 100%;
    height: 24px;
    background-color: #f7f7f7;
}

.cell {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    /* padding: 32px 0; */
    height: 90px;
}

.h-90 {
    height: 90px;
}

.h-110 {
    height: 110px;

}

.cell-upload {
    box-sizing: border-box;
    padding: 32px 0;
}

.cell-link {
    box-sizing: border-box;
    padding: 32px 0;
}

.input-link {
    border: none;
    font-size: 26px;
    background-color: #f4f5f5;
    /* width: 148px; */
    height: 58px;
    flex: 1;
    padding-left: 40px;
    border-radius: 30px 0 0 30px;
}

.btn-sync {
    background-color: #4995f0;
    color: #ffffff;
    font-size: 28px;
    border-radius: 0 30px 30px 0;
    border: none;
    width: 148px;
    height: 58px;
}

.underline {
    border-bottom: 1px solid #ebedf0;
}

.label {
    font-size: 28px;
    flex-shrink: 0;
}

.input {
    border: none;
    margin-left: 58px;
    flex: 1;
}

.ml-58 {
    margin-left: 58px;
}

.cell-title {
    box-sizing: border-box;
    padding: 0px 28px 0 40px;
    text-align: left;
    font-size: 32px;
    font-weight: 500;
    position: relative;
}

.cell-title::before {
    content: "";
    width: 4px;
    height: 28px;
    display: block;
    position: absolute;
    top: 50%;
    left: 28px;
    transform: translate(-50%, -50%);
    background-color: #861517;
}


.textarea {
    width: 618px;
    height: 157px;
    margin-top: 24px;
    font-size: 28px;
    box-sizing: border-box;
    padding: 10px;
}

.padding-bottom-20 {
    padding-bottom: 20px;
}

.font-size-22 {
    font-size: 22px;
}

.btn-submit {
    width: 500px;
    height: 80px;
    background-color: #4995f0;
    border-radius: 50px;
    margin: 15px 0 30px;
    color: #ffffff;
    border: none;
    font-size: 32px;
}

.datePicker-box {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
}

/* slider-wrap */
.slider-wrap {
    display: flex;
    align-items: center;
    margin-top: 16px;
}

.slider {
    box-sizing: border-box;
    padding: 0 24px;
    flex: 1;
}

.option_img {
    width: 100px;
    height: 100px;
    border-radius: 50% !important;
    box-sizing: border-box;
    margin: 12px 12px 0 0;
}

.cur {
    border: 2px solid #861517;
}

.ico_selected {
    position: absolute;
    right: 0;
    bottom: 0;
}

.color-block {
    width: 100px;
    height: 100px;
    margin-right: 3px;
}

.picker-wrap {
    background-color: transparent !important;
    padding: 16px
        /* z-index: 999; */
}

.btn-radio__group {
    border: 1px solid #dcdfe6;
    border-right: none;
}

.btn-radio__item {
    min-width: 80px;
    box-sizing: border-box;
    padding: 8px 15px;
    border-right: 1px solid #dcdfe6;
}

.cur_btn {
    background-color: #861517 !important;
    color: #fff;
}

.can_multi {
    font-size: 12px;
}


.ico_people {
    width: 186px;
    height: 372px;
    margin: 0 24px
}


.daItemList {
    display: flex;
    flex-direction: column;
    flex-basis: 33.3%;
    margin-top: 24px;

}

.daItem {
    width: 72px;
    height: 72px;
    border-radius: 36px;
    position: relative;
}


.uploadImg-wrap {
    margin-bottom: 20px;
}

.img {
    width: 162px;
    height: 162px;
}

.imgclose {
    position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
    width: 64px;
    height: 64px;
}

.fixed-bottom {
    position: fixed;
    bottom: 0px;
    left: 0;
    width: 100vw;
    padding-bottom: 24px;
    background-color: #fff;
    z-index: 99;
}

.w-b-wrap {
    width: 600px;
    height: 490px;
    display: flex;

}

.w-b_left {
    width: 192px;
    height: 490px;
}

.w-b_right {
    width: 408px;
    height: 490px;
    background-image: url("https://mp.yijugongshe.com/upload/backgroundimg/w-b_right_v3.png");
    background-size: 100% 100%;
    position: relative;
}

.w-b__circle {
    width: 100px;
    height: 100px;
    /* width: 4px;
    height: 4px; */
    border-radius: 50%;
    box-sizing: border-box;
    border: 4px solid #ee0a24;
    position: absolute;

}

.no-click {
    pointer-events: none;
}

.delete-button {
    height: 100%;
}

.title-wrap {
    box-sizing: border-box;
    padding: 0 24px 0 0;
}

/* vant */
.custom-button {
    width: 40px;
    line-height: 28px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    background-color: #ee0a24;
    border-radius: 100px;
}

.van-radio--horizontal {
    margin-top: 12px;
}

.van-checkbox--horizontal {
    margin-top: 12px;
}
</style>